export default "__VITE_ASSET__CbQh6o7___"